import { Box } from "@chakra-ui/react"
import dynamic from "next/dynamic"
import { useBrandedTranslation } from "../../../../common/hooks/useBrandedTranslation"
import antiXss from "../../../../common/utils/anti-xss"
import { AlertBox } from "../../../shared/AlertBox"
import { CInfo } from "../../../shared/Icons"
const RichTextLabel = dynamic(() => import("../../../shared/RichTextLabel"), {
  ssr: false,
})

type Props = {
  originalSearchTerm: string
}

const CorrectionHint = ({ originalSearchTerm }: Props) => {
  const { t } = useBrandedTranslation()
  const sanitizedOriginalSearchTerm = antiXss(originalSearchTerm)

  return (
    <Box as="section" mb={{ base: "4", sm: "6", md: "8" }}>
      <AlertBox colorSide="brand.500" colorMain="brand.50" icon={<CInfo w="6" h="6" color="white" />}>
        <RichTextLabel i18nKey={t("search-no-results-header_rtf", { searchTerm: sanitizedOriginalSearchTerm })} />
      </AlertBox>
    </Box>
  )
}

export default CorrectionHint
